import React, { useState, useContext } from 'react';
import { Col, Input, Row } from 'antd';
import imageUrl from '../images/Logo.png';
import { SearchOutlined } from '@ant-design/icons';
import { GithubContext } from '../context/context';

const Header = () => {
  const [user, setUser] = useState('');
  const {  searchGithubUser,  } = useContext(
    GithubContext
  );
  //Get things from context globally
  const handleSubmit = (e) => {
    e.preventDefault();
    if (user) {
      searchGithubUser(user);
      setUser('');
    }
  };

  return (
    <Row  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
      <Col xs={8} sm={10} md={12}>
        <img src={imageUrl} style={{ maxWidth: '100%' }} />
      </Col>
      <Col xs={16} sm={14} md={12}>
      <form onSubmit={handleSubmit}>
          <div className="form-control">
          <Input
              type="text"
              placeholder="search user"
              value={user}
              onChange={(e) => {
                setUser(e.target.value);
              }}
              placeholder="Search Users"
              suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.45)' }} />}
            />
          </div>
        </form>
  
      </Col>
    </Row>
  );
};

export default Header;
